import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { isKYCCompleted } from '../../utils/kycUtils';

interface KYCRedirectProps {
  to: string;
  children: React.ReactNode;
  delay?: number;
}

const KYCRedirect = ({ to, children, delay = 2000 }: KYCRedirectProps) => {
  const { user } = useAuth();
  const [shouldRedirect, setShouldRedirect] = useState(false);
  const isKycCompleted = isKYCCompleted(user);

  useEffect(() => {
    if (isKycCompleted) {
      return;
    }

    const timer = setTimeout(() => {
      setShouldRedirect(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay, isKycCompleted]);

  if (isKycCompleted) {
    return <>{children}</>;
  }

  if (shouldRedirect) {
    return <Navigate to={to} replace />;
  }

  return (
    <>
      <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 w-full max-w-2xl px-4">
        <div className="bg-red-50 border-l-4 border-red-400 px-4 py-2 rounded-lg shadow-lg flex items-center gap-3">
          <AlertCircle className="h-4 w-4 text-red-600 flex-shrink-0" />
          <p className="text-sm text-red-700 flex-1">
            Complete Your KYC Verification - Your KYC verification is
            incomplete. Please complete your identity verification to access all
            features.
          </p>
        </div>
      </div>
      {children}
    </>
  );
};

export default KYCRedirect;
